import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

const Loading = () => {
  return (
    <Dimmer active={true} inverted>
      <Loader size="massive">لطفا منتظر بمانید</Loader>
    </Dimmer>
  );
};

export default Loading;
